import { render, staticRenderFns } from "./vuecommatrs.vue?vue&type=template&id=5075146a&scoped=true"
import script from "./vuecommatrs.vue?vue&type=script&lang=js"
export * from "./vuecommatrs.vue?vue&type=script&lang=js"
import style0 from "./vuecommatrs.vue?vue&type=style&index=0&id=5075146a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5075146a",
  null
  
)

export default component.exports